var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-page',[_c('div',{staticClass:"omapi-settings"},[_c(_vm.componentName,{tag:"component",scopedSlots:_vm._u([{key:"tabs",fn:function(){return [_c('common-tabnav',{attrs:{"active":_vm.currentTab,"tabs":_vm.allTabs},on:{"go":_vm.goTo}})]},proxy:true}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }